export default __webpack_public_path__ + "static/media/img6.a82b0c51.PNG";